import Logo from './Logo'
import styles from './Footer.module.less'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
function Index({ history }) {
  const { t, i18n } = useTranslation()
  return (
    <footer className={styles.footer}>
      <div className="mod">
        <Logo className={styles.logo} />
        <div className={styles.info}>
          <p>
            <a href="http://about.starworldgames.com/ch/termsofuse.html" target="_blank" rel="noreferrer">游戏服务及许可协议 </a>
            <a href="http://about.starworldgames.com/ch/privacy-policy.html" target="_blank" rel="noreferrer">游戏隐私协议 </a>
            <a href="mailto:game@360.cn">游戏商务合作</a>
            <a href="http://mis.h5.u.360.cn/wcn/index.htm" target="_blank" rel="noreferrer">游戏组件未成年人家长监护工程 </a>
            <a href="http://p0.qhimg.com/t0169dceb0c0d596fcd.jpg" target="_blank" rel="noreferrer">北京世界星辉科技有限责任公司 </a>
            {/* <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035516">公安备案号11010502035516</a>
            <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备11029981号-10</a>
            <a href="http://p9.qhimg.com/t01761af2b8a4fcb737.jpg">京网文【2021】0038-009号</a>
            <span>京ICP证京B2-20170671</span>
            <a href="http://p8.qhimg.com/t01472b264bd8ef7708.jpg">趣游时代（北京）科技有限公司</a> */}
          </p>
          <p>
            <a href="https://wan.360.cn/icp-images.html" target="_blank" rel="noreferrer">京ICP证 140771号 </a>
            <a href="https://beian.miit.gov.cn" target='_blank' rel="noreferrer">京ICP备11014623号-30 </a>
            <a href="https://p0.ssl.qhimg.com/t01e18ae0227afa2aa5.png" target="_blank" rel="noreferrer">京网文[2018]9597-828号  </a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000006" target="_blank" rel="noreferrer">京公网安备 11000002000006号 </a>
          </p>
          <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活 </p>
          {/* <p>商务联系电话：010-68608366-8110 传真：010-68608355</p> */}
        </div>
      </div>
    </footer>
  );
}

export default Index;
